import { Music } from 'lucide-react';

interface AudioPreviewProps {
  src: string;
  mimeType: string | null;
  fileName: string | null;
}

export function AudioPreview({ src, mimeType, fileName }: AudioPreviewProps) {
  return (
    <div
      className="flex flex-1 flex-col items-center justify-center gap-6 p-8"
      data-testid="project-files-audio-preview"
    >
      <div className="flex size-24 items-center justify-center rounded-2xl bg-muted">
        <Music className="size-12 text-muted-foreground" />
      </div>

      {fileName && <p className="max-w-xs truncate text-center text-sm font-medium">{fileName}</p>}

      <audio controls className="w-full max-w-sm">
        {mimeType ? <source src={src} type={mimeType} /> : <source src={src} />}
      </audio>
    </div>
  );
}
